<template>
  <div class="msgTip">
    <div class="name">{{ props.message.sender.nickname }}</div>
    <div class="d_text">{{ props.message.message }}</div>
  </div>
</template>
<script setup name="msgTip">
const props = defineProps({
  message: {
    type: Object,
    default: {},
  },
});
</script>
<style scoped>
.msgTip {
  margin-bottom: 1.6vw;
  display: flex;
  align-items: center;
}
.name {
  color: #6898df;
  font-family: PingFang SC;
  font-size: 3.46vw;
  font-weight: 400;
  line-height: 5.86vw;
}
.d_text {
  color: #94a3b8;
  font-family: PingFang SC;
  font-size: 3.46vw;
  font-weight: 400;
  line-height: 5.86vw;
  margin-left: 2px;
}
</style>
